import React from 'react';

// Helpers
import { isWeb } from '../helpers';

export const AppContext = React.createContext({
    
    isWeb: isWeb(),
    network: {}
});